import { FiChevronDown } from 'react-icons/fi';
import BookCard from '../../components/shop/BookCard';
import { SkeletonBookGrid } from '../../components/common/Skeleton';

export const ShopGrid = ({
  loading,
  filteredBooks,
  visibleBooks,
  hasMore,
  onLoadMore,
  onClearFilters,
}) => {
  if (loading) return <SkeletonBookGrid count={15} />;

  if (filteredBooks.length === 0) {
    return (
      <p className="text-center py-16">
        <span className="text-black text-lg block">No books found</span>
        <span className="text-black text-sm mt-2 block">
          Try adjusting your filters or search query
        </span>
        <button
          onClick={onClearFilters}
          className="mt-4 bg-orange-600 text-white px-6 py-2 rounded hover:bg-orange-700 transition text-sm"
        >
          Clear Filters
        </button>
      </p>
    );
  }

  return (
    <>
      <ul className="grid grid-cols-[repeat(2,minmax(0,1fr))] sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 sm:gap-4 list-none w-full min-w-0">
        {visibleBooks.map((book) => (
          <li key={book.id}>
            <BookCard book={book} />
          </li>
        ))}
      </ul>

      {hasMore && (
        <div className="flex justify-center mt-8">
          <button
            type="button"
            onClick={onLoadMore}
            className="inline-flex items-center gap-2 bg-orange-600 text-white text-sm font-semibold px-6 py-2.5 rounded-full hover:bg-orange-700 shadow-sm transition"
          >
            Know more
            <FiChevronDown className="text-base" />
          </button>
        </div>
      )}
    </>
  );
};
